import { usePathname } from 'next/navigation'
import { Box, styled } from '@mui/joy'
import { pxToRem } from '@ui/style/muiTheme'
import color from '@ui/style/color.theme'
import { getDarkMode } from '@hooks/useDarkModeControl'
import { useCommentTotalCount } from '@store/comments/commentTotalCount'
import useIsMounted from '@hooks/useIsMounted'

interface BadgeProps {
	// eslint-disable-next-line react/no-unused-prop-types
	dark?: boolean
	top?: number
	right?: number
}

interface CommentCountBadgeProps {
	id: string
	styles?: Pick<BadgeProps, 'top' | 'right'>
}

const Badge = styled(Box)(({ dark, top, right }: BadgeProps) => ({
	padding: `${pxToRem(1)} ${pxToRem(3)}`,
	color: color.colWhite,
	backgroundColor: dark ? color.colDarkmodePointBlue : color.colPointBlue,
	borderRadius: pxToRem(8),
	fontSize: pxToRem(11),
	lineHeight: 1.1,
	height: pxToRem(14),
	minWidth: pxToRem(14),
	position: 'absolute',
	top: top !== undefined ? pxToRem(top) : 0,
	right: right !== undefined ? pxToRem(right) : pxToRem(5),
}))

const CommentCountBadge = ({ id, styles }: CommentCountBadgeProps) => {
	const pathname = usePathname()
	const isMounted = useIsMounted()
	const isDarkMode = getDarkMode(pathname)
	const { commentList } = useCommentTotalCount()

	const { count: commentTotalCount = 0 } = commentList.find((comment) => comment.id === id) || {}

	if (!isMounted || commentTotalCount === 0) {
		return null
	}

	return (
		<Badge dark={isDarkMode} top={styles?.top} right={styles?.right}>
			{commentTotalCount > 999 ? '999+' : commentTotalCount}
		</Badge>
	)
}
export default CommentCountBadge
